import {Navigate, useLocation, useParams} from 'react-router-dom';

type Props = {
  to: string;
};

export default function RedirectWithParams({ to }: Props) {
  const { tab } = useParams();
  const location = useLocation();
  const path = tab ? `${to}/${tab}` : to;

  return <Navigate to={`${path}${location.search}`} replace />;
}
